import { render, staticRenderFns } from "./Wp_tb_order_count_new.vue?vue&type=template&id=3a473e78&scoped=true&"
import script from "./Wp_tb_order_count_new.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_order_count_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a473e78",
  null
  
)

export default component.exports